import { motion } from "framer-motion";
import { Mail, Phone, Instagram, Globe } from "lucide-react";

const contacts = [
  {
    icon: Mail,
    label: "Email",
    value: "UrbanovaSkopje@gmail.com",
    href: "mailto:UrbanovaSkopje@gmail.com",
  },
  {
    icon: Phone,
    label: "Phone",
    value: "+389 70 803 787",
    href: "tel:+38970803787",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "@UrbanovaSkopje",
    href: "https://instagram.com/UrbanovaSkopje",
  },
  {
    icon: Globe,
    label: "Booking.com",
    value: "Book on Booking.com",
    href: "https://booking.com",
    external: true,
  },
  {
    icon: Globe,
    label: "Airbnb",
    value: "Book on Airbnb",
    href: "https://airbnb.com",
    external: true,
  },
];

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 md:py-32 px-6 md:px-16">
      <div className="max-w-6xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-muted-foreground font-body text-sm tracking-[0.3em] uppercase mb-3">
            Get in touch
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4">
            Ready to book?
          </h2>
          <p className="font-body text-muted-foreground max-w-md mx-auto mb-12">
            Reach out via email, phone, or Instagram to reserve your stay at Urbanova.
          </p>
        </motion.div>

        {/* Top row: Email, Phone, Instagram */}
        <div className="grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto mb-4">
          {contacts.filter((c) => !(c as any).external).map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target={c.label === "Instagram" ? "_blank" : undefined}
              rel={c.label === "Instagram" ? "noopener noreferrer" : undefined}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-card border border-border rounded-xl p-6 hover:border-foreground/20 transition-all group"
            >
              <c.icon className="w-6 h-6 text-foreground mx-auto mb-3 group-hover:scale-110 transition-transform" />
              <p className="font-body text-xs text-muted-foreground uppercase tracking-wider mb-1">
                {c.label}
              </p>
              <p className="font-body text-sm font-medium text-foreground">
                {c.value}
              </p>
            </motion.a>
          ))}
        </div>

        {/* Bottom row: Booking.com, Airbnb */}
        <div className="grid sm:grid-cols-2 gap-4 max-w-xl mx-auto">
          {contacts.filter((c) => (c as any).external).map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i + 3) * 0.1 }}
              className="bg-card border border-border rounded-xl p-6 hover:border-foreground/20 transition-all group"
            >
              <c.icon className="w-6 h-6 text-foreground mx-auto mb-3 group-hover:scale-110 transition-transform" />
              <p className="font-body text-xs text-muted-foreground uppercase tracking-wider mb-1">
                {c.label}
              </p>
              <p className="font-body text-sm font-medium text-foreground">
                {c.value}
              </p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
